import { Component, OnInit, AfterViewInit, ElementRef, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import * as $ from 'jquery';
// import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-macwordplugin',
  templateUrl: './macwordplugin.component.html',
  styleUrls: ['./macwordplugin.component.scss']
})

export class MacwordpluginComponent implements OnInit, AfterViewInit {

  deviceInfo = null;
  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    // private deviceDetectorService: DeviceDetectorService
  ) { }
  
  ngOnInit() {
    // this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
    // console.log(this.deviceInfo);
    this.titleService.setTitle("Microsoft Word（Mac版）用Trinkaアドイン | Trinka");
    this.metaTagService.updateTag({ name: 'description', content: "AI英文校正ツールTrinka（トリンカ）が、Mac版Microsoft Word上で、あなたの書いた文章をチェック。Trinkaのパワフルな機能をMacでも。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Microsoft Word（Mac版）用Trinkaアドイン | Trinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "AI英文校正ツールTrinka（トリンカ）が、Mac版Microsoft Word上で、あなたの書いた文章をチェック。Trinkaのパワフルな機能をMacでも。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/ms-word-addin-for-mac' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/maclite-banner.svg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Microsoft Word（Mac版）用Trinkaアドイン | Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "AI英文校正ツールTrinka（トリンカ）が、Mac版Microsoft Word上で、あなたの書いた文章をチェック。Trinkaのパワフルな機能をMacでも。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/maclite-banner.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/ms-word-addin-for-mac' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/wordplugin-lite' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/wordplugin-lite' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/ms-word-addin-for-mac' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/ms-word-addin-for-mac' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/ms-word-addin-for-mac' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/ms-word-addin-for-mac' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/ms-word-addin-for-mac' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/ms-word-addin-for-mac' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit(){
    $.getScript('../../../jp/assets/js/home_client_slider.js', function () { });
  }

  

}
